import { ref } from 'vue';

const addToUrl = (url, params) => `${url}?${Object.keys(params)
  .map(k => `${k}=${params[k]}`)
  .join('&')}`;

const templateElement = document.getElementById('partnerinfobox-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    kreditorId: String,
    isVersandDurchBreuninger: Boolean,
    isOversizedShipping: Boolean,
  },

  setup(props) {
    const layerModal = ref(null);
    const layerModalContent = ref(null);
    const partnerUrl = ref(null);

    const fetchData = async (url) => {
      const res = await fetch(url);
      if (res.status !== 200) {
        throw new Error(`fetch returned non successfully status code: ${res.status}`);
      }
      return res.text();
    };

    const openLayer = async (e) => {
      e.preventDefault();
      let url = partnerUrl.value.getAttribute('data-href');

      const params = {};
      if (props.kreditorId) {
        params.kreditorid = props.kreditorId;
      }
      if (props.isVersandDurchBreuninger) {
        params.isVersandDurchBreuninger = 'true';
      }

      if (props.isOversizedShipping) {
        params.isOversizedShipping = 'true';
      }

      url = addToUrl(url, params);
      layerModal.value.classList.remove('hidden');

      try {
        const html = await fetchData(url);
        layerModalContent.value.innerHTML = html;
      } catch {
        layerModalContent.value.innerText = 'Something went wrong. Please try again later.';
      } finally {
        layerModal.value.show();
      }
    };

    return {
      layerModal,
      layerModalContent,
      partnerUrl,
      openLayer,
    };
  },
};
